/**
 * Created by Ning Jiang on 2024-04-17.
 */

import {DeadwoodRipSymbol} from "./DeadwoodRipSymbol";
import {DeadwoodRipSymbolState} from "./DeadwoodRipSymbolConfig";
import {TimelineLite} from "gsap";

export class DeadwoodRipS3Symbol extends DeadwoodRipSymbol {

    private _isAttentionPlaying:boolean;

    constructor(reelId:number, initState:DeadwoodRipSymbolState) {
        super("S3", reelId, initState);
    }

    public split(type:number, noWin:boolean):TimelineLite {
        return new TimelineLite();
    }

    protected getOnShotAnimationName():string {
        return `S3_Shoot`;
    }

    protected getCharacterAssetName():string {
        return "S3";
    }

    public playAttention():TimelineLite {
        this._isAttentionPlaying = true;
        this.createDeadContainer();
        const tl = new TimelineLite();
        tl.add(() => {
            this._deadCharacter.visible = true;
            this._deadCharacter.state.setAnimation(1, "landing", false);
            this._parts.forEach(p => {
                p.visible = false;
            });
        });
        tl.add(() => {
            if(this._isAttentionPlaying) {
                this._deadCharacter.state.setAnimation(1, "attention", true);
            }
        }, `+=${this._deadCharacter.spineData.findAnimation("landing").duration}`);
        return tl;
    }

    public stopAttention():void {
        this._isAttentionPlaying = false;
        this.createDeadContainer();
        // this._deadCharacter.state.setAnimation(1, "landing", false).time = this._deadCharacter.spineData.findAnimation("landing").duration;
    }

    public playFeatureWin():TimelineLite {
        this.createDeadContainer();
        const tl = new TimelineLite();
        tl.add(() => {
            this._deadCharacter.visible = true;
            this._deadCharacter.state.setAnimation(1, "win", false);
        });
        tl.add(() => {}, `+=${this._deadCharacter.spineData.findAnimation("win").duration}`);
        return tl;
    }
}